function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Listing.css';
import React, { Fragment, useState } from 'react';
// import RouterLink from '../RouterLink';
import { get, getDictionaryItem, canUseDOM, getListingLocation, getPageThemeColors, getColorByTheme, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { POIBlock } from './../34_POIs/POIs';
import { ArticleBlock } from '../02_Articles/Articles';
import EventBlock from "../15_Events/components/EventBlock";
import FeaturedEventBlock from "../15_Events/components/FeaturedEventBlock";
import { ItenaryBlock, commonStyles as itemStyles } from '../26_Itineraries/Itineraries';
import { CuratorBlock, commonStyles as curatorltrStyles, rtlStyles as curatorRtlStyles, emptyModalVideo, videplayerStyles } from '../10_Curators/Curators';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacetsWithoutPlusReplacement, getAlgoliaTagsList } from './index';
import { getAnaliticsParamFromArray, tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { UniversityBlock } from './UniversityBlock';
import { DealBlock } from './ListingBlocks/DealBlock';
import { DealModalBlock } from './ListingBlocks/DealModalBlock';
import { ServicesBlock } from './ListingBlocks/ServicesBlock';
import { eventDatesRange } from './DateRange';
import { ANNUAL_FEE } from './index';
import { VideoBlock, videoMedia } from '../BrightcoveVideos';
import { VenueBlock } from '../VenueBlock/VenueBlock';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import ResultItem from '../DynamicListingComponent/ResultItem';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { checkJssError } from '../../utils/checkJssError';
import InteractiveMapModal from '../atoms/InteractiveMapModal/InteractiveMapModal';
import { getInteractiveModalMapConfig } from '../atoms/InteractiveMapModal/utils/getInteractiveModalMapConfig';
import throttle from 'lodash/throttle';
import clsx from 'clsx';
import Loader from '../atoms/Loader/Loader';
import { ReactComponent as IconPauseItem } from '../../resources/icons/IconPauseFat.svg';
import { ReactComponent as IconPlay } from '../../resources/icons/IconPlay2.svg';
import useProfile from '../../utils/hooks/useProfile';
const getFacetNamesValue = filterData => {
  if (filterData && Array.isArray(filterData.values)) {
    const values = filterData.values.map(filter => {
      const item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      const item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      const facet = item1 || item2 || 'datesRange';
      if (facet === 'maxDelegates') {
        return 'maxDelegatesRangeIndex';
      }
      return facet;
    });
    return values;
  } else {
    return [];
  }
};
const wrappedClasses = {
  'type:Event': 'col-12 col-xl-9 offset-xl-1',
  'type:POI': 'offset-xl-1 col-xl-9',
  'type:Restaurant': 'offset-xl-1 col-xl-9',
  'type:Article Insights': 'offset-xl-1 col-xl-9',
  'type:Long Report Overview': 'offset-xl-1 col-xl-9',
  'type:Venue': 'offset-xl-1 col-xl-9',
  'type:Curator': 'offset-xl-1 col-xl-9',
  'type:Itineraries': 'curator-featured offset-xl-1 col-xl-11',
  'type:University': 'offset-xl-1 col-xl-11',
  'type:Services Page': 'offset-xl-1 col-xl-11',
  'type:Listing deal': 'offset-xl-1 col-xl-11',
  'type:Listing trade event': 'offset-xl-1 col-xl-11',
  'type:Listing vendor': 'offset-xl-1 col-xl-11',
  'type:Video Details Page': 'offset-xl-1 col-xl-9'
};
const ListingComponent = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const modalVideo = React.useRef(null);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageTitle = get(sitecoreContext, 'route.fields.Title.value') || '';
  const currentLang = get(sitecoreContext, 'language');
  const userProfile = useProfile();
  const searchIndexParams = get(params, 'SearchIndex', '');
  const fieldsData = get(fields, 'data', {});
  const [fieldsColorTheme] = get(route, 'fields.Color Theme', [{}]);
  const mapConfigurationЫSource = get(fields, 'data.listingConfiguration.mapConfiguration');
  const mapConfiguration = mapConfigurationЫSource ? mapConfigurationЫSource[0] : [];
  const mapModalTitle = get(mapConfiguration, 'title.jss.value') || '';
  const mapModalContentType = get(fields, 'data.listingConfiguration.contentType.types[0].template.targetItem.value') || '';
  const mapModalDefaultMapZoom = Number(get(mapConfiguration, 'defaultMapZoom.jss.value')) || 10;
  const mapModalCentreMapLatitude = Number(get(mapConfiguration, 'centreMapLatitude.jss.value')) || 25.2048493;
  const mapModalCentreMapLongitude = Number(get(mapConfiguration, 'centreMapLongitude.jss.value')) || 55.2707828;
  const mapModalColor = get(mapConfiguration, 'colourTheme.item.backgroundColor.jss.value') || 'var(--main-color)';
  const withMapModalView = getInteractiveModalMapConfig(mapConfiguration);
  // max number algolia can sent by 1 request
  const maxPageSize = 1000;
  const backgroundPrimaryColor = get(fieldsColorTheme, 'fields.Primary.fields.backgroundColor.value', '');
  const messageSearchResultEmpty = get(fieldsData, 'contextItem.messageSearchResultEmpty.value', '');
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters') || [];
  const isTagPage = get(fields, 'data.listingConfiguration.isTagPage.jss.value');
  const filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  const pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value'));
  const dictionary = get(fields, 'data.dictionary');
  const mapDictionary = get(fields, 'data.mapDictionary');
  const imageDictionary = get(fields, 'data.imageDictionary');
  const curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  const byCopy = getDictionaryItem(dictionary, 'By');
  const MinRead = getDictionaryItem(dictionary, 'MinRead');
  const LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  const day = getDictionaryItem(dictionary, 'Day') || 'day';
  const days = getDictionaryItem(dictionary, 'Days') || 'days';
  const showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  const resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  const clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  const selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'Select all';
  const Cancel = getDictionaryItem(dictionary, 'Cancel') || 'Cancel';
  const FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  const seeMore = getDictionaryItem(dictionary, 'SeeMore') || 'See More';
  const viewedNofMLabel = `${getDictionaryItem(dictionary, 'YouHaveViewed')} {#loadedHits#} ${getDictionaryItem(dictionary, 'Of')} {#nbHits#} ${getDictionaryItem(dictionary, 'Items')}`;
  const multipleDates = getDictionaryItem(dictionary, 'multipleDates') || 'Multiple days, next on';
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const [result, setResult] = React.useState();
  const [facets, setFacets] = React.useState();
  const [defaultFacets, setdefaultFacets] = React.useState();
  const [facetsStats, setFacetsStats] = React.useState({});
  const [hits, setHits] = React.useState([]);
  const [allHits, setAllHits] = React.useState([]);
  const [nbHits, setNbHits] = React.useState(0);
  const [page, setpage] = React.useState(0);
  const [firstRendering, setFirstRendering] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [buttonPressed, setButtonPressed] = React.useState(false);
  const [modalVideoState, setModalVideoState] = useState(emptyModalVideo);
  const [resetFilter, setResetFilter] = React.useState(false);
  const [resetAllFilters, setResetAllFilters] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [currentTypes, applycurrentTypes] = React.useState([]);
  const [currentType, applycurrentType] = React.useState('');
  const [firstType, applyFirstType] = React.useState('');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const location = useLocation();
  const {
    isShown,
    toggle
  } = useModal();
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const [dealModalItem, setIdDealModalItem] = React.useState({});
  const [isChina, setIsChina] = React.useState(false);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [dateRangeValue, setDateRangeValue] = React.useState({
    date: '',
    dateInit: undefined,
    formattedDate: ''
  });
  const isFirstLoadWithoutFacets = React.useRef(false);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const socialSharing = get(fields, 'data.socialSharing');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  React.useEffect(() => {
    if (canUseDOM && document.body) {
      const primaryColor = selectedPrimaryColor;
      const color = getColorByTheme(selectedPrimaryColor);
      const activeColor = selectedPrimaryActiveColor;
      document.body.style.setProperty('--venue-table-background-color', primaryColor);
      document.body.style.setProperty('--venue-table-background-active-color', activeColor);
      document.body.style.setProperty('--venue-table-color', color);
    }
  }, []);
  const queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  let facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, filterData);
  let firstload = true;
  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      const urlParams = new URLSearchParams(document.location.search);
      const isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  }, []);

  //get default facets for types
  React.useEffect(() => {
    const queryIndexes = Object.keys(queryParams).filter(k => k.indexOf(`${searchIndexParams}_asc_`) > -1)[0];
    let algoliaIndexes = '';
    if (queryIndexes) {
      algoliaIndexes = queryIndexes;
    } else {
      algoliaIndexes = get(params, 'SearchIndex');
    }
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      // value
      // if (value === 'Single Day Itinerary') value = 'Single Day Itinerary Page';
      // if (value === 'Multiple Days Itinerary') value = 'Multiple Days Itinerary Page';

      return `type:${value == 'Service' ? '' : value}`;
    });
    const facetNames = getFacetNamesValue(filterData);
    const itemFilters = {
      facets: [...facetNames],
      facetFilters: [[...types], [tag]],
      hitsPerPage: 1,
      page: page
    };
    getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
      setdefaultFacets(response.facets);
    });
    if (!isChina) {
      const search = location.search;
      let urlParameter = new URLSearchParams(search).get('deal');
      if (urlParameter) {
        urlParameter = urlParameter.replaceAll('-', ' ');
        let itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Listing deal', 'type:Listing trade event', 'type:Listing vendor']],
          query: urlParameter
        };
        getListing(algoliaIndexes, itemFilter, algoliaSettings).then(response => {
          if (response && response.hits.length !== 0) {
            response.hits.forEach(hit => {
              if (urlParameter && hit.urlParameter.toLowerCase() === urlParameter.toLowerCase()) {
                setIdDealModalItem(hit);
              }
            });
            toggle();
          }
        });
      }
    }
  }, []);
  const href = typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.href : null;
  let prevFacetFilters = usePrevious(facetFilters);
  const prevPage = usePrevious(page);
  React.useEffect(() => {
    const queryIndexes = Object.keys(queryParams).filter(k => k.indexOf(`${searchIndexParams}_asc_`) > -1)[0];
    let algoliaIndexes = '';
    if (queryIndexes) {
      algoliaIndexes = queryIndexes;
    } else {
      algoliaIndexes = get(params, 'SearchIndex');
    }
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    const applyTypes = []; // equates type Restaurant to POI
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      if (value === "Restaurant") {} // ignore type Restaurant (the same as POI)
      else {
        applyTypes.push(`type:${value}`);
      }
      return `type:${value}`;
    });
    applycurrentTypes(applyTypes); // currentTypes should be ONLY 1 item in array
    applycurrentType(applyTypes[0]);
    applyFirstType(get(applyTypes, '0'));
    const facetNames = getFacetNamesValue(filterData);
    let filters;
    if (queryParams.datesRange) {
      filters = queryParams.datesRange.split('+').join(' ');
    } else {
      let filterValues = getAlgoliaTagsList(filterData);
      if (filterValues.indexOf(eventDatesRange) > -1) {
        filters = `datesRange.to > ${Date.parse(new Date()) / 1000}`;
      }
      if (~filterValues.indexOf(ANNUAL_FEE) && queryParams[ANNUAL_FEE]) {
        filters = `${queryParams[ANNUAL_FEE]}`.split('+').join(' ');
      }
      var filtersData = [];
      if (filterValues.indexOf('totalHotelRooms') > -1 && queryParams['totalHotelRooms']) {
        filtersData.push(`totalHotelRooms ${queryParams['totalHotelRooms'].split('+').join(' ')}`);
      }
      if (filtersData.length) {
        filters = filtersData.map(query => `(${query})`).join(' AND ');
      }
    }
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    applycurrentType(facetFilters[0]);
    const itemFilters = {
      filters,
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFilters, [tag]],
      hitsPerPage: pagesize,
      page: page
    };
    const allItemFilters = {
      filters,
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFilters, [tag]],
      hitsPerPage: maxPageSize,
      page: 0
    };
    const listingRequestAllItems = () => {
      setLoading(true);
      let promisesQueue = [];
      let finalResponse = [];
      let pageNumber = 1;
      getListing(algoliaIndexes, allItemFilters, algoliaSettings).then(response => {
        if (response.hits) {
          applySetFilters(false);
          finalResponse = [...response.hits];
          finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
          setAllHits(finalResponse);

          // nbPages - max available items per page
          if (pageNumber < response.nbPages) {
            // create array of promisses
            for (let i = 1; i < response.nbPages; i++) {
              const itemFilterCopy = _objectSpread({}, allItemFilters);
              itemFilterCopy.page = i;
              promisesQueue.push(itemFilterCopy);
            }
            if (promisesQueue.length) {
              Promise.all(promisesQueue.map(item => {
                getListing(algoliaIndexes, item, algoliaSettings).then(responses => {
                  // summarize all the hits by all request
                  finalResponse = [...finalResponse, ...responses.hits];
                  finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
                }).then(() => {
                  setAllHits(finalResponse);
                  setTimeout(() => setLoading(false), 1000);
                }).catch(function (error) {
                  console.log(error);
                });
              }));
            }
          }
        }
      }).then(() => {
        setTimeout(() => setLoading(false), 1000);
        setResetAllFilters(false);
      });
    };
    const listingRequest = () => {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
        setFacets(response.facets);
        setResult(response);
        applySetFilters(false);
        setNbHits(response.nbHits);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            const resultsBlocks = document.querySelectorAll('.results');
            if (resultsBlocks.length) {
              const lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              const focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                const lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(hits.concat(response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = () => {};
          }
        }, 100);
        setLoading(false);
        setFirstRendering(false);
        setResetAllFilters(false);
      });
    };
    if (resetAllFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else if (setFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
          if (withMapModalView) {
            listingRequestAllItems();
          }
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters]);
  const resetFilterCallback = () => {
    setFacets(undefined);
    setResult(undefined);
    // setNbHits(0);
    // setNbHits2(0);
    setHits([]);
    setpage(0);
    setResetFilter(true);
    console.log('reset filters');
  };
  const resetAllFiltersCallback = () => {
    setResetAllFilters(true);
  };
  const {
    filterMeetingRoomLayoutAnalytics,
    bannerClickAnalytics,
    listingItemAnalytics,
    titleClickAnalytics,
    visitWebsite: visitWebsiteAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    exploreMoreAnalytics,
    mobileSlidesAnalytics,
    socialAnalytics,
    seeMoreAnalytics,
    readMoreAnalytics,
    filterAnalytics,
    filterShowResultsAnalytics,
    filterClearAllDateAnalytics,
    filterSelectDateAnalytics,
    filterClickAnalytics,
    smallBannerClickAnalytics,
    expandCollapseAnalytics,
    buttonClickAnalytics
  } = fields.data;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const analytics = get(fields, 'data.analytics.parameters');
  const loadMore = () => {
    if (canUseDOM) {
      var x = window.scrollX;
      var y = window.scrollY;
      window.onscroll = () => {
        window.scrollTo(x, y);
      };
    }
    setButtonPressed(true);
    setpage(prevState => prevState + 1);
    if (eventsAnalytics["loadMoreAnalytics"]) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["loadMoreAnalytics"], params));
    }
  };
  const setListingFilter = filtersRecived => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    // setdefaultFacets(result && result.facets);
    setFacetsStats(result && result.facets_stats);
    console.log('setListingFilter');
    isFirstLoadWithoutFacets.current = firstRendering && facetFilters.length === 0;
  };
  React.useEffect(() => {
    if (modalVideoState.type === 'media') {
      let timer;
      if (modalVideoState.visiblePlayButton) {
        timer = setTimeout(() => {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            visiblePlayButton: false
          }));
        }, 2000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [modalVideoState]);
  React.useEffect(() => {
    if (isShown) {
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        visiblePlayButton: true
      }));
    }
  }, [isShown]);
  const modalPlayButtonHandler = () => {
    if (modalVideo.current) {
      if (modalVideoState.playing) {
        modalVideo.current.pause();
      } else {
        modalVideo.current.play();
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        playing: !modalVideoState.playing
      }));
    }
  };
  let checkMouseMoved;
  if (canUseDOM) {
    checkMouseMoved = throttle(() => {
      if (!modalVideoState.visiblePlayButton) {
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          visiblePlayButton: true
        }));
      }
    }, 300);
  }
  const renderVideo = styles => {
    if (!modalVideoState.src || !modalVideoState.type) {
      return null;
    }
    if (modalVideoState.type === 'external') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          toggle();
          setModalVideoState(emptyModalVideo);
        },
        className: clsx(styles, 'modal-yt-iframe-container')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-yt-iframe-ar-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        width: "560",
        height: "315",
        src: modalVideoState.src,
        title: modalVideoState.title,
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "modal-yt-iframe"
      })));
    }
    if (modalVideoState.type === 'media') {
      return /*#__PURE__*/React.createElement("div", {
        onMouseMove: checkMouseMoved,
        className: clsx(styles, {
          'hidden-play-button': !modalVideoState.visiblePlayButton
        })
      }, /*#__PURE__*/React.createElement("video", {
        ref: modalVideo,
        className: clsx('modal-video', {
          'modal-video--load-over': !modalVideoState.loading
        }),
        playsInline: true,
        loop: true,
        onProgress: () => {
          if (modalVideoState.loading) {
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              loading: false
            }));
          }
        },
        muted: false,
        preload: "auto",
        autoPlay: false
      }, /*#__PURE__*/React.createElement("source", {
        src: modalVideoState.src,
        type: "video/mp4"
      }), /*#__PURE__*/React.createElement("track", {
        kind: "captions"
      })), modalVideoState.loading ? /*#__PURE__*/React.createElement(Loader, {
        color: "#000000"
      }) : /*#__PURE__*/React.createElement("button", {
        className: clsx('btn--reset modal-play-button', {
          'modal-play-button--playing': modalVideoState.playing
        }),
        onClick: modalPlayButtonHandler
      }, modalVideoState.playing ? /*#__PURE__*/React.createElement(IconPauseItem, null) : /*#__PURE__*/React.createElement(IconPlay, null)));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, Object.keys(dealModalItem).length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: toggle
  }, /*#__PURE__*/React.createElement(DealModalBlock, {
    event: dealModalItem,
    lang: currentLang,
    hostLink: isTagPage ? '' : getListingLocation(),
    analytics: socialAnalytics,
    params: params,
    fields: fields,
    pageTitle: pageTitle,
    rtl: rtl
  }))), filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: filterData,
    currentTypes: currentTypes,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: isTagPage,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    imageDictionary: imageDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    analytics: {
      filterAnalytics,
      filterShowResultsAnalytics,
      filterClearAllDateAnalytics,
      filterSelectDateAnalytics,
      filterClickAnalytics,
      filterMeetingRoomLayoutAnalytics,
      params
    },
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    dateRangeValue: dateRangeValue,
    getDateRangeValue: incomingDateObj => setDateRangeValue(incomingDateObj),
    withMapConfig: withMapModalView,
    skipFacetsFilter: true
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row itinerary-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: wrappedClasses[currentType] || 'offset-xl-1 col-xl-9'
  }, /*#__PURE__*/React.createElement("div", {
    className: `common-listing-styles ${facetFilters}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits.map((hit, index) => {
    if (hit.type.indexOf('Event') != -1 && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Event')) {
      if (hit && hit.featured && index === 0) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "events__featured-block"
        }, /*#__PURE__*/React.createElement(FeaturedEventBlock, {
          userProfile: userProfile,
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: isTagPage ? '' : getListingLocation(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics,
            params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)],
          isListing: true
        }))));
      } else {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, hit && hit.featured && index === 0 ? null : /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-sm-6 col-md-4 events-item-col-outer d-flex"
        }, /*#__PURE__*/React.createElement(EventBlock, {
          userProfile: userProfile,
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: isTagPage ? '' : getListingLocation(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics,
            params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)],
          isListing: true
        })));
      }
    }
    if (hit.type.indexOf('Article') != -1 && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 article-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        copyBy: byCopy,
        copyMinread: MinRead,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          eventsAnalytics,
          params
        },
        isListing: true
      }));
    }
    if (~hit.type.indexOf('PressRelease') && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:PressRelease')) {
      return /*#__PURE__*/React.createElement(ResultItem, {
        key: index,
        item: hit,
        language: currentLang,
        params: params,
        analitycs: {
          bannerClickAnalytics: bannerClickAnalytics,
          listingItemAnalytics: listingItemAnalytics
        }
      });
    }
    if (hit.type.indexOf('Article Insights') != -1 && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article Insights')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 article-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        key: index,
        copyBy: byCopy,
        copyMinread: MinRead,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          eventsAnalytics,
          params
        },
        isListing: true
      }));
    }
    if (hit.type.indexOf('Long Report Overview') != -1 && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Long Report Overview')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 article-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        copyBy: byCopy,
        copyMinread: MinRead,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          eventsAnalytics,
          params
        },
        isListing: true
      }));
    }
    if (hit.type.indexOf('Venue') != -1 && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Venue')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 article-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(VenueBlock, {
        item: hit,
        dictionary: dictionary,
        copyBy: byCopy,
        copyMinread: MinRead,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          titleClickAnalytics,
          bannerClickAnalytics,
          addToFavAnalytics,
          seeMoreAnalytics,
          readMoreAnalytics,
          addToFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Add Venue To Shortlist Param'), '0'),
          removeFromFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Remove Venue From Shortlist Param'), '0'),
          params
        }
      }));
    }
    if (~hit.type.indexOf('Curator') && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Curator')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 curator-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(CuratorBlock, {
        item: hit,
        seeMore: seeMore,
        analytics: {
          eventsAnalytics,
          params
        },
        modalVideoState: modalVideoState,
        isMultipleSocialMedia: true,
        setModalVideoState: setModalVideoState,
        toggle: toggle,
        hostLink: location.pathname,
        selectedPrimaryColor: 'var(--main-color)',
        parentParams: params
      }));
    }
    if ((~hit.type.indexOf('POI') || ~hit.type.indexOf('Restaurant')) && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:POI')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 poi-item-col",
        key: index
      }, /*#__PURE__*/React.createElement(POIBlock, {
        item: hit,
        curatorsCopy: curatorPick,
        hostLink: isTagPage ? '' : getListingLocation(),
        dictionary: getDictionaryItem(dictionary, 'reviews') || '',
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          params
        },
        isListing: true
      }));
    }
    if (~hit.type.indexOf('Itineraries') && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Itineraries')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "curator-container",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "curator-container__row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-main-container"
      }, /*#__PURE__*/React.createElement(ItenaryBlock, {
        item: hit,
        day: day,
        curatorsCopy: curatorPick,
        days: days,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          bannerClickAnalytics,
          smallBannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          params
        }
      }))));
    }
    if (~hit.type.indexOf('University')) {
      const anualFee = getDictionaryItem(dictionary, 'Annual Fee Range') || 'Anual Fee Range';
      const fieldOfStudy = getDictionaryItem(dictionary, 'Field Of Study') || 'Field of study';
      const visitWebsite = getDictionaryItem(dictionary, 'Visit website') || 'Visit website';
      const AED = getDictionaryItem(dictionary, 'AED') || 'AED';
      const universityDescription = getDictionaryItem(dictionary, 'university description');
      return /*#__PURE__*/React.createElement("div", {
        className: "university-container",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "university-container__row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "university-main-container"
      }, /*#__PURE__*/React.createElement(UniversityBlock, {
        hit: hit,
        rtl: rtl,
        lang: {
          anualFee,
          visitWebsite,
          universityDescription,
          fieldOfStudy,
          AED
        },
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          visitWebsiteAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          params
        }
      }))));
    }
    if (~hit.type.indexOf('Services Page')) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "col-sm-4 col-12"
      }, /*#__PURE__*/React.createElement(ServicesBlock, {
        service: hit,
        hostLink: "",
        rtl: rtl
      }));
    }
    if (~hit.type.indexOf('Listing deal') || ~hit.type.indexOf('Listing trade event') || ~hit.type.indexOf('Listing vendor')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "deal-container",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "deal-container__row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "deal-main-container"
      }, /*#__PURE__*/React.createElement(DealBlock, {
        event: hit,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          expandCollapseAnalytics,
          buttonClickAnalytics
        },
        params: params,
        route: route,
        fields: fields,
        socialSharing: socialSharing,
        socialAnalytics: socialAnalytics
      }))));
    }
    if (facetFilters.length && facetFilters[0].length && facetFilters[0][0].includes('type') ? ~hit.type.indexOf('Video Details Page') && facetFilters[0][0] === 'type:Video Details Page' : ~hit.type.indexOf('Video Details Page')) {
      return /*#__PURE__*/React.createElement("div", {
        className: `videoHolder ${videoMedia}`
      }, /*#__PURE__*/React.createElement(VideoBlock, {
        item: hit,
        index: index,
        hostLink: '',
        key: index,
        analytics: analytics,
        params: params,
        discoverMoreLink: isTagPage ? '' : getListingLocation()
      }));
    }
    if (currentTypes.length === 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
        key: index
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        copyBy: byCopy,
        copyMinread: MinRead,
        lang: currentLang,
        hostLink: isTagPage ? '' : getListingLocation(),
        analytics: {
          eventsAnalytics,
          params
        },
        isListing: true
      }));
    }
  })))))), !loading && !hits.length && /*#__PURE__*/React.createElement("div", {
    className: "load-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "message-search-result-empty"
  }, messageSearchResultEmpty)), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel
  })), withMapModalView && /*#__PURE__*/React.createElement(InteractiveMapModal, {
    loading: loading,
    params: params,
    hits: allHits,
    mainHitsPerPage: `${pagesize}`,
    mainTitle: mapModalTitle,
    contentType: mapModalContentType,
    defaultMapZoom: mapModalDefaultMapZoom,
    centreMapLatitude: mapModalCentreMapLatitude,
    centreMapLongitude: mapModalCentreMapLongitude,
    mapModalColor: mapModalColor,
    dictionary: mapDictionary,
    eventsAnalytics: eventsAnalytics,
    filtersComponent: filterValue && filterValue.length >= 1 ? /*#__PURE__*/React.createElement(Filters, {
      dateRangeValue: dateRangeValue,
      getDateRangeValue: incomingDateObj => setDateRangeValue(incomingDateObj),
      params: params,
      fields: filterData,
      currentTypes: currentTypes,
      facets: facets,
      defaultFacets: defaultFacets,
      facetsStats: facetsStats,
      showLabel: showLabel,
      resultsLabel: resultsLabel,
      nbHits: nbHits,
      clearAllLabel: clearAllLabel,
      selectAllLabel: selectAllLabel,
      setListingFilter: setListingFilter,
      resetFilterCallback: resetFilterCallback,
      day: day,
      days: days,
      Cancel: Cancel,
      FiltersCopy: FiltersCopy,
      isTagPage: isTagPage,
      lang: currentLang,
      hits: hits,
      dictionary: dictionary,
      imageDictionary: imageDictionary,
      firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
      analytics: {
        filterAnalytics,
        filterShowResultsAnalytics,
        filterClearAllDateAnalytics,
        filterSelectDateAnalytics,
        filterClickAnalytics,
        filterMeetingRoomLayoutAnalytics,
        params
      },
      resetAllFiltersCallback: resetAllFiltersCallback,
      searchIndex: searchIndexParams,
      withMapModalView: true,
      withMapConfig: withMapModalView
    }) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }), /*#__PURE__*/React.createElement(Modal, {
    showMobileClose: true,
    fullPageCover: true,
    fullPageVideo: true,
    isShown: isShown,
    hide: () => {
      toggle();
    }
  }, actualSSR ? null : renderVideo(videplayerStyles))));
};
const Listing = props => checkJssError(props, ListingComponent);
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `  ${eventStyle} ${poiStyle} ${articleStyle} ${itemStyles} ${loadMoreButtonStylesLtr} ${curatorltrStyles} ${curatorStyle} ${commonStyles} ${rtl ? curatorRtlStyles : curatorltrStyles} ${rtl ? stylesRTL : stylesLTR} `
  }, children);
};
export const commonStyles = "co4jqy7";
export const eventStyle = "ei4f5f5";
export const articleStyle = "a1rnu77p";
export const poiStyle = "px53hkw";
export const curatorStyle = "c12t6lpn";
export const stylesLTR = "s165yyvh";
export const stylesRTL = "s1ocobdo";
export default Listing;